module.exports = __webpack_public_path__ + "img/9-5.1f16f92a.jpg";